@if (!editMode && !saving) {
  <div class="frequency-details">
    <label class="standalone-label">Email notification frequency</label>
    <div class="flex flex-between-center">
      <p>{{ frequency }}</p>
      @if (canEdit) {
        <button
          (click)="edit()"
          class="small-button flex-[0_0_auto]"
          color="primary"
          data-test-id="notification-frequency-edit-button"
          mat-button
          title="Edit notification frequency preference"
          type="button"
        >
          Edit
        </button>
      }
    </div>
  </div>
}
@if (editMode || saving) {
  <edit-notification-frequency
    [frequency]="frequency"
    [saving]="saving"
    (editResult)="onEditResult($event)"
    data-test-id="edit-notification-frequency-container"
  ></edit-notification-frequency>
}
